import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../config/brand";
import { FadeUp, LineReveal, Eyebrow } from "../components/Reveal";

export const FAQ = () => (
  <section id="faq" className="scroll-mt-20 bg-blushcream/60" aria-label="Frequently asked questions" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-12 px-5 py-20 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:py-28">
      <div className="lg:col-span-4">
        <FadeUp>
          <Eyebrow>Questions</Eyebrow>
        </FadeUp>
        <LineReveal
          as="h2"
          lines={["Everything you'd", "want to ask."]}
          className="mt-4 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl"
        />
        <FadeUp delay={0.15}>
          <p className="mt-5 max-w-sm text-base leading-relaxed text-plumcharcoal/75">
            Clear answers before you decide—because you should know exactly
            what you're getting.
          </p>
        </FadeUp>
      </div>
      <div className="lg:col-span-8">
        <FadeUp delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="-mx-4 rounded-2xl border-b border-mauve/35 px-4 transition-colors duration-300 data-[state=open]:bg-warmwhite/80"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i + 1}`}
                  data-analytics-event="faq_open"
                  className="py-6 text-left font-serif text-xl font-semibold tracking-tight text-plum transition-colors hover:text-rose hover:no-underline sm:text-2xl [&[data-state=open]]:text-rose"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  className="pb-6 text-base leading-relaxed text-plumcharcoal/70"
                  data-testid={`faq-answer-${i + 1}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </div>
  </section>
);
